import { useGoogleLogin } from "@react-oauth/google";
import { useSetRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import useApm from "../utils/apm";
import { authAtom } from "../state";
import { Button, Grid } from "@mui/material";
import { HOSTED_DOMAIN } from "../constants";
import { useAuthApiClient } from "../api/auth";
import jwtDecode from "jwt-decode";

const LoginPage = () => {
  const setAuth = useSetRecoilState(authAtom);
  const apm = useApm();
  const authApiClient = useAuthApiClient();
  let navigate = useNavigate();
  const { state } = useLocation();
  let from = state?.from?.pathname || "/";

  const login = useGoogleLogin({
    hosted_domain: HOSTED_DOMAIN,
    prompt: "consent select_account",
    flow: "auth_code",
    onSuccess: async ({ code }) => {
      const authResponse = await authApiClient.exchangeAuthorizationCode(code);
      const userProfile = jwtDecode(authResponse.idToken);

      setAuth({
        name: userProfile.name,
        picture: userProfile.picture,
        ...authResponse,
      });

      apm.setUserContext({
        email: userProfile.email,
        username: userProfile.name,
      });

      navigate(from, { replace: true });
    },
    onError: () => {
      console.log("login failed");
    },
  });

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={3}>
        <Button variant="contained" onClick={() => login()} size="large">
          Sign In with Google
        </Button>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
